import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import IntelligenceLeaderboard from "@/pages/IntelligenceLeaderboard";

export const Route = createFileRoute("/_app/intelligence/leaderboard")({
  component: () => (
    <PageGate pageKey="intelligence"><IntelligenceLeaderboard /></PageGate>
  ),
});
